import { HttpEvent, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Auth } from "@angular/fire/auth";
import { from, Observable, switchMap } from "rxjs";

export const AuthInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => {
    const auth = inject(Auth);

    if (!auth.currentUser) {
        return next(req);
    }

    return from(auth.currentUser.getIdToken()).pipe(
        switchMap((token) => {
            if (!token) {
                return next(req);
            }

            const headers = req.headers.set("id-token", token);
            const authReq = req.clone({ headers });
            return next(authReq);
        })
    );
};
